"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAvatarLetter = exports.StyledAvatar = exports.StyledMessageContainer = exports.StyledMargin = exports.StyledGraphic = exports.StyledHeader = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledHeader = styled_components_1.default.div `
  font: bold ${config_1.fontSizes.large} ${config_1.fontFamilies.primary};
  margin-bottom: 15px;
`;
exports.StyledGraphic = styled_components_1.default.img `
  height: 220px;
  width: 220px;
`;
exports.StyledMargin = styled_components_1.default.div `
  margin: ${({ top, right, bottom, left }) => [top || 0, right || 0, bottom || 0, left || 0].join(' ')};
`;
exports.StyledMessageContainer = styled_components_1.default.div `
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 515px;
  justify-content: center;
  max-height: ${({ height }) => (height ? height : '550px')};
`;
exports.StyledAvatar = styled_components_1.default.div `
  background: ${config_1.colors.pavement};
  align-items: center;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  margin-right: 15px;
  width: 60px;
  height: 60px;
`;
exports.StyledAvatarLetter = styled_components_1.default.div `
  font: Bold ${config_1.fontSizes.extraLarge} ${config_1.fontFamilies.primary};
  color: ${config_1.colors.thundercloud};
  margin: 0;
`;
